/**
 * Arabic overlays for blog SEO posts (premium native copy).
 */

export interface BlogPostArOverlay {
  title: string;
  excerpt: string;
  category: string;
  date: string;
  faq?: { question: string; answer: string }[];
  contentHtml?: string;
}

export const BLOG_POSTS_AR: Record<string, BlogPostArOverlay> = {
  "1": {
    title: "أفضل النصائح لتجربة تأجير ناجحة",
    excerpt: "نصائح عملية لتحقيق أقصى استفادة من تأجير سيارتك وتجنب الأخطاء الشائعة.",
    category: "نصائح",
    date: "15 يناير 2024",
  },
  "2": {
    title: "كيف تختار السيارة المناسبة لاحتياجاتك؟",
    excerpt: "دليل شامل لاختيار المركبة المثالية حسب وجهتك وعدد الركاب وتفضيلاتك.",
    category: "دليل",
    date: "10 يناير 2024",
  },
  "3": {
    title: "التأمين والحماية: كل ما يجب معرفته",
    excerpt: "شرح واضح للضمانات المشمولة في العروض وكيفية حماية نفسك بفعالية.",
    category: "تأمين",
    date: "5 يناير 2024",
  },
  "4": {
    title: "أفضل 10 وجهات لاكتشاف المغرب بالسيارة",
    excerpt: "اكتشف أجمل الطرق في المغرب ووجهات لا تُفوَّت مع سيارة مستأجرة.",
    category: "سفر",
    date: "1 يناير 2024",
  },
  "5": {
    title: "كم يكلف تأجير سيارة في المغرب؟",
    excerpt: "متوسط الأسعار وعوامل التكلفة ونصائح للحصول على أفضل قيمة.",
    category: "دليل",
    date: "20 فبراير 2024",
    faq: [
      {
        question: "ما متوسط سعر تأجير السيارة في المغرب؟",
        answer: "تختلف الأسعار حسب المدينة والموسم والفئة. على RAKB، كل إعلان يعرض السعر اليومي الحقيقي لتواريخك — قارن دون افتراض سعر موحّد.",
      },
      {
        question: "ما العوامل التي تؤثر على السعر؟",
        answer: "الموسم، المدة، فئة المركبة، الخيارات (توصيل المطار، خفض التحمل) والمدينة.",
      },
    ],
  },
  "6": {
    title: "تأجير سيارة بـ 150 درهم في المغرب: هل هو ممكن؟",
    excerpt: "كثير من الباحثين يستهدفون «150 درهم»: كيف تفهم هذا الميزانية وتحجز بالسعر المناسب على RAKB.",
    category: "نصائح",
    date: "22 فبراير 2024",
    faq: [
      {
        question: "هل تأجير بـ 150 درهم/اليوم موثوق؟",
        answer: "وكالات RAKB الشريكة موثّقة. قد تظهر سيارات صغيرة قرب هذا المستوى حسب التوفر، لكن السعر الدقيق دائماً على الإعلان لتواريخك — وليس ضماناً لكل حجز.",
      },
    ],
  },
  "7": {
    title: "تأجير سيارة مطار الدار البيضاء: دليل شامل",
    excerpt: "كل ما تحتاجه لاستلام سيارتك من مطار محمد الخامس: الحجز والأسعار والإجراءات.",
    category: "دليل",
    date: "25 فبراير 2024",
    faq: [
      {
        question: "أين أستلم سيارتي في مطار الدار البيضاء؟",
        answer: "وكالات RAKB الشريكة تسلّم المركبة مباشرة في مطار محمد الخامس (CMN). أدخل رقم رحلتك عند الحجز.",
      },
    ],
  },
  "8": {
    title: "هل يلزم تأمين/وديعة لتأجير سيارة في المغرب؟",
    excerpt: "كيف تعمل الوديعة في المغرب وخيارات تقليلها ونصائح عملية.",
    category: "نصائح",
    date: "28 فبراير 2024",
    faq: [
      {
        question: "كم مبلغ الوديعة عادةً؟",
        answer: "يختلف حسب الوكالة والمركبة، غالباً بين 2000 و5000 درهم. يُحجز على بطاقتك ويُسترد عند الإرجاع السليم.",
      },
    ],
  },
  "9": {
    title: "تأجير سيارة للسياح في المغرب",
    excerpt: "دليل للمسافرين الدوليين: الوثائق والتأمين ونصائح عملية.",
    category: "سفر",
    date: "2 مارس 2024",
  },
  "10": {
    title: "تأجير طويل الأمد في المغرب: أسبوع أو شهر",
    excerpt: "أسعار مخفّضة والإجراءات ونصائح للإيجار لعدة أسابيع أو أشهر.",
    category: "دليل",
    date: "5 مارس 2024",
  },
  "11": {
    title: "ما الوثائق المطلوبة لتأجير سيارة في المغرب؟",
    excerpt: "الرخصة والهوية والبطاقة البنكية: القائمة الكاملة.",
    category: "نصائح",
    date: "8 مارس 2024",
  },
  "12": {
    title: "كيف تجد تأجيراً اقتصادياً في الدار البيضاء؟",
    excerpt: "نصائح ومقارنة العروض للحصول على أفضل سعر في الدار البيضاء.",
    category: "نصائح",
    date: "10 مارس 2024",
  },
  "13": {
    title: "تأجير سيارة مطار مراكش المنارة: دليل",
    excerpt: "استلام سيارتك من مطار المنارة: الحجز والأسعار والنصائح.",
    category: "دليل",
    date: "12 مارس 2024",
  },
  "14": {
    title: "ما الحد الأدنى للعمر لتأجير سيارة في المغرب؟",
    excerpt: "قواعد العمر وأقدمية الرخصة حسب الوكالات والفئات.",
    category: "نصائح",
    date: "15 مارس 2024",
  },
  "15": {
    title: "إلغاء وتعديل حجز التأجير في المغرب",
    excerpt: "شروط الإلغاء والرسوم والمرونة حسب عروض RAKB.",
    category: "نصائح",
    date: "18 مارس 2024",
  },
  "16": {
    title: "تأجير اقتصادي في الرباط: نصائحنا",
    excerpt: "أين وكيف تقارن العروض في الرباط وتحجز بالسعر المعروض لتواريخك.",
    category: "دليل",
    date: "20 مارس 2024",
  },
  "17": {
    title: "تأجير سيارة في مراكش للسياح",
    excerpt: "دليل عملي: مطار المنارة والمدينة والمدينة القديمة والرحلات.",
    category: "سفر",
    date: "22 مارس 2024",
  },
  "18": {
    title: "تأجير في طنجة: المطار وميناء طنجة المتوسط",
    excerpt: "استلام سيارتك من مطار ابن بطوطة أو بعد العبّارة.",
    category: "دليل",
    date: "25 مارس 2024",
  },
  "19": {
    title: "خفض التحمل وخيارات التأمين في المغرب",
    excerpt: "افهم التحمل وكيف تقلّله وتختار الخيارات المناسبة.",
    category: "تأمين",
    date: "28 مارس 2024",
  },
  "20": {
    title: "لماذا تستخدم منصة مقارنة لتأجير السيارات في المغرب؟",
    excerpt: "مزايا مقارنة العروض (السعر، التقييمات، الشروط) قبل الحجز.",
    category: "نصائح",
    date: "1 أبريل 2024",
  },
  "21": {
    title: "تأجير مطار الدار البيضاء: السعر الحقيقي والوديعة والحجز السريع",
    excerpt: "دليل للحجز في مطار محمد الخامس بأسعار واقعية وخيارات الوديعة دون مفاجآت.",
    category: "دليل",
    date: "15 أبريل 2024",
    faq: [
      {
        question: "ما السعر الواقعي للتأجير في مطار الدار البيضاء؟",
        answer: "يختلف حسب الموسم والمدة والفئة. على RAKB، رشّح حسب تواريخك — السعر الدقيق على كل بطاقة قبل الحجز.",
      },
      {
        question: "هل يلزم وديعة عند الاستلام في محمد الخامس؟",
        answer: "نعم، غالباً تطلب الوكالات وديعة بين 2000 و5000 درهم حسب الفئة والتأمين.",
      },
    ],
    contentHtml: `
    <p>إذا وصلت إلى الدار البيضاء وتريد سيارة فوراً، هذا الدليل يركّز على المقارنة السريعة والحجز بثقة وتجنب الرسوم المفاجئة.</p>
    <h2>الأسعار في مطار محمد الخامس</h2>
    <p>يعتمد السعر على الموسم والمدة والفئة. قارن السيارات الاقتصادية أولاً وتحقق من الكيلومترات وسياسة الوقود قبل التأكيد.</p>
    <h2>الوديعة والتأمين والوثائق</h2>
    <p>جهّز الرخصة والهوية والبطاقة البنكية. راجع التحمل والاستثناءات وطريقة حجز الوديعة.</p>
    <h2>خطوات الحجز الموصى بها</h2>
    <p>رشّح حسب المدينة والتواريخ والفئة. قارن الشروط لا السعر فقط. اختر وكالة موثّقة وأكّد رحلتك لتنسيق التسليم في المطار.</p>
    `,
  },
};
